import SocialMedia from '../model/SocialMedia'
import Image from '../model/Image'
import Facebook from '@/images/facebook.png'
import LinkedIn from '@/images/linkedin.png'
import Github from '@/images/github.png'
import Stackoverflow from '@/images/stackoverflow.png'

export const FACEBOOK = "facebook"
export const LINKEDIN = "linkedin"
export const GITHUB = "github"
export const STACKOVERFLOW = "stackoverflow"

interface urlStruct {
    [key: string]: string
}

const mediaURL: urlStruct = {
    [FACEBOOK]: "https://web.facebook.com/james.riady.520",
    [LINKEDIN]: "https://www.linkedin.com/in/james-r-4b5a4699/",
    [GITHUB]: "https://github.com/jamesriady",
    [STACKOVERFLOW]: "https://stackoverflow.com/users/7179399/saengdaet"
}

interface MediaStruct {
    [key: string]: SocialMedia
}

export const Medias: MediaStruct = {
    [FACEBOOK]: new SocialMedia("Facebook", mediaURL[FACEBOOK], new Image(Facebook)),
    [LINKEDIN]: new SocialMedia("LinkedIn", mediaURL[LINKEDIN], new Image(LinkedIn)),
    [GITHUB]: new SocialMedia("Github", mediaURL[GITHUB], new Image(Github)),
    [STACKOVERFLOW]: new SocialMedia("Stackoverflow", mediaURL[STACKOVERFLOW], new Image(Stackoverflow)),
}